dygraphs is MIT-licenced and fully human-made.

Copyright (c) 2006, 2009, 2011, 2012, 2013, 2017
	Dan Vanderkam <danvdk@gmail.com>
Copyright (c) 2011 Paul Felix <paul.eric.felix@gmail.com>
Copyright (c) 2011, 2013 Robert Konigsberg <konigsberg@google.com>
Copyright (c) 2013 David Eberlein <david.eberlein@ch.sauter-bc.com>
Copyright (c) 2013 Google, Inc.
Copyright (c) 2015 Petr Shevtsov <petr.shevtsov@gmail.com>
Copyright (c) 2014, 2022, 2023, 2025, 2026
	mirabilos <m$(date +%Y)@mirbsd.de>
and numerous contributors (see git log)

Some tests additionally are:

Copyright (c) 2011, 2012 Google, Inc. <danvk@google.com>
or contributed by:
- Benoit Boivin <benoitboivin.pro@gmail.com>
- Paul Felix <paul.eric.felix@gmail.com>
- Marek Janda <nyx@nyx.cz>
- Robert Konigsberg <konigsberg@google.com>
- George Madrid <gmadrid@gmail.com>
- Anthony Robledo <antrob@google.com>
- Fr. Sauter AG <julian.eichstaedt@ch.sauter-bc.com>
- Fr. Sauter AG <david.eberlein@ch.sauter-bc.com>
- Ümit Seren <uemit.seren@gmail.com>
- Sergey Slepian <sergeyslepian@gmail.com>
- Dan Vanderkam <dan@dygraphs.com>

Parts of the documentation are or make use of code that is:

Copyright (c) 2012 Google, Inc.
- Robert Konigsberg <konigsberg@google.com>

Parts contributed by Deutsche Telekom LLCTO.

Further contributors can be found in the git history or on:
https://github.com/danvk/dygraphs/graphs/contributors

The automatically added umd and browser-pack shims are:

Copyright (c) 2013 Forbes Lindesay <forbes@lindesay.co.uk>
Copyright (c) 2013, 2014 James Halliday <mail@substack.net>
Copyright (c) 2013 Roman Shtylman <shtylman@gmail.com>
Copyright (c) 2013 Esa-Matti Suuronen <esa-matti@suuronen.org>
Copyright (c) 2018 Philipp Simon Schmidt <github@philippsimon.de>

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE.

The documentation and gallery uses Bootstrap and jQuery; see the
relevant licence files of those external libraries for details.

docs/aint.png is CC0-licenced, by Bethan Tovey-Walsh, via
https://linguacelta.com/aint/

The icons under common/ are CC0-licenced and adapted by mirabilos.
In Debian, /usr/share/common-licenses/CC0-1.0 has the full text.
